import { SwalMessage, ToastMessage } from '../../Tools'


// initial
var ProductRatingHandle = function () {


    var CanvasLoad = function (productId, userId) {

        const bsOffcanvas = new bootstrap.Offcanvas('#canvasAssessment')
        bsOffcanvas.show();

        $.ajax({
            url: apiUrl + '/GetCustomerCommentCanvasLoad',
            type: "POST",
            dataType: "json",
            async: false,
            data: {
                product_id: productId,
                user_id: userId,
            },
            error: function error(xhr) {
                //console.log(xhr);
            },
            success: function success(xhr) {
                //console.log(xhr);

                let canvas = document.querySelector('#canvasAssessment')

                let product = xhr.product;

                // ürün
                let productPicture = JSON.parse(product.thumbnail)[langCodeLong];
                if (productPicture == null || productPicture == undefined) {
                    productPicture = JSON.parse(product.thumbnail)[langCodeLongDefault];
                }

                let productName = JSON.parse(product.title)[langCodeLong];
                if (productName == null || productName == undefined) {
                    productName = JSON.parse(product.title)[langCodeLongDefault];
                }

                canvas.querySelector('.product .product-name').innerText = productName
                canvas.querySelector('.product .product-image').setAttribute('src', productPicture)

                document.querySelector('#canvasAssessment input[name="fullname"]').value = xhr.user.name
                document.querySelector('#canvasAssessment input[name="customer_id"]').value = xhr.user.id
                document.querySelector('#canvasAssessment input[name="product_id"]').value = xhr.product.id

                $('#canvasAssessment .stars .selected').each(function () {
                    $(this).removeClass('selected');
                });
            }
        });
    }

    var handle = function () {

        $(document).on('click', '[data-order-product-voiting]', function (event) {
            event.preventDefault();

            let userId = this.getAttribute('data-user-id')
            let productId = event.target.closest('.product').getAttribute('data-product-id')

            CanvasLoad(productId, userId)

        })

        $('#canvasAssessment').on('click', '.rating .stars .fa-star', function (e) {
            $('#canvasAssessment .stars .selected').each(function () {
                $(this).removeClass('selected');
            });
            $(this).addClass('selected');

            let voting = $(this).attr('data-voting')

            document.querySelector('#canvasAssessment input[name="voting"]').value = voting
        });

        $(document).on('click', '[data-canvas-close="comment"]', function (event) {
            event.preventDefault();
            $('#canvasAssessment .stars .selected').each(function () {
                $(this).removeClass('selected');
            });
            $('#canvasAssessment [data-bs-dismiss="offcanvas"]').click();
        })

        // yorum gönder
        $(document).on('click', '[data-canvas-save="comment"]', function (event) {
            event.preventDefault();

            let formAction = document.querySelector('#canvasAssessment').querySelector('form')

            $.ajax({
                url: apiUrl + '/CreateProductComment',
                type: "POST",
                dataType: "json",
                data: $(formAction).serialize(),
                error: function error(xhr) {
                    $.each(xhr.responseJSON.errors, function (name, message) {

                        let element = form.querySelector('[name="' + name + '"]')

                        element.classList.add('is-invalid')

                        let valid = element.closest('div')
                            .querySelector('.invalid-feedback');
                        valid.style.display = 'block'
                        valid.innerHTML = message;

                    });
                },
                success: function success(xhr) {
                    SwalMessage(
                        {
                            type: 'success',
                            text: xhr.text ?? xhr.message,
                            confirmButton: translate.ok_button,
                        },
                        function () {
                            location.reload();
                        }
                    );
                }
            });

        })

    }


    return {
        init: function () {
            handle();
        },
    };

}();


$(function () {
    ProductRatingHandle.init();
});